import type { FilterConfig, FilterEnumOption } from '#lib/apps/types.js';

// TomTom Functional Road Class values
// FIXME: if we get text values
const frcValues = [0, 1, 2, 3, 4, 6, 7];

const frcOptions: FilterEnumOption[] = frcValues.map((v) => ({
	value: String(v),
	label: String(v)
}));

export const filters: FilterConfig[] = [
	{
		id: 'frc',
		label: 'Functional Road Class',
		options: frcOptions
	}
];
